/* NORTHBITE Kaufbox: Dosen frei wählbar (Plus/Minus, Schnellwahl), Mengenrabatt
   nach Staffel, Einmalkauf/Abo. Preise und Abo-Anpassungen kommen aus dem Shop.
   Die Staffel (data-tiers, "Menge:Prozent") muss zu den automatischen Rabatten
   im Shopify-Admin passen: dort wird im Warenkorb wirklich abgezogen. */
(function () {
  function money(cents, cur, digits) {
    if (digits === undefined) digits = 2;
    try { return (cents / 100).toLocaleString('de-AT', { style: 'currency', currency: cur, minimumFractionDigits: digits, maximumFractionDigits: digits }); }
    catch (e) { return (cents / 100).toFixed(digits).replace('.', ',') + ' ' + cur; }
  }
  function parseGrams(title, fallbackGrams) {
    var m = /(\d+(?:[.,]\d+)?)\s*(g|kg)\b/i.exec(title || '');
    if (!m) return fallbackGrams;
    var g = parseFloat(m[1].replace(',', '.'));
    return m[2].toLowerCase() === 'kg' ? g * 1000 : g;
  }
  function parseTiers(str) {
    return String(str || '').split(',').map(function (t) { var a = t.split(':'); return { min: parseInt(a[0], 10), pct: parseFloat(a[1]) }; })
      .filter(function (t) { return t.min > 0 && t.pct > 0; }).sort(function (a, b) { return a.min - b.min; });
  }
  function planPrice(base, type, value) {
    if (type === 'percentage') return Math.round(base * (1 - value / 100));
    if (type === 'fixed_amount') return Math.max(0, base - value);
    if (type === 'price') return value;
    return base;
  }
  function cansText(n) { return n === 1 ? '1 Dose' : n + ' Dosen'; }
  function init(root) {
    if (root.__nb) return; root.__nb = true;
    var cur = root.dataset.currency || 'EUR';
    var unit = parseInt(root.dataset.unitPrice, 10) || 0;
    var grams = parseGrams(root.dataset.unitTitle, parseFloat(root.dataset.grams) || 800);
    var tiers = parseTiers(root.dataset.tiers);
    var maxQ = parseInt(root.dataset.max, 10) || 99;
    var vid = root.querySelector('[data-ew-vid]');
    var planIn = root.querySelector('[data-ew-plan]');
    var priceEl = root.querySelector('[data-ew-price]');
    var wasEl = root.querySelector('[data-ew-was]');
    var unitLine = root.querySelector('[data-ew-unitline]');
    var yearLine = root.querySelector('[data-ew-yearsave]');
    var btnText = root.querySelector('[data-ew-btntext]');
    var plansBox = root.querySelector('[data-ew-plans]');
    var modeSave = root.querySelector('[data-ew-modesave]');
    var qtyIn = root.querySelector('[data-ew-qty]');
    var qtyBox = root.querySelector('[data-ew-qtybox]');
    var cansUnit = root.querySelector('[data-ew-cansunit]');
    var tierEl = root.querySelector('[data-ew-tier]');
    var dec = root.querySelector('[data-ew-qdec]'), inc = root.querySelector('[data-ew-qinc]');
    var picks = Array.prototype.slice.call(root.querySelectorAll('[data-ew-pick]'));
    var plans = Array.prototype.map.call(root.querySelectorAll('[data-ew-planopt]'), function (inp) {
      return { inp: inp, label: root.querySelector('label[for="' + inp.id + '"]'), type: inp.dataset.type, value: parseFloat(inp.dataset.value) || 0, yearly: inp.dataset.yearly === 'true' };
    });
    function clamp(q) { q = parseInt(q, 10); if (!q || q < 1) q = 1; if (q > maxQ) q = maxQ; return q; }
    function qty() { var q = clamp(qtyIn ? qtyIn.value : 1); if (qtyIn && String(q) !== qtyIn.value) qtyIn.value = q; return q; }
    function setQty(q) { if (qtyIn) qtyIn.value = clamp(q); update(); }
    function tierFor(q) { var hit = null; tiers.forEach(function (x) { if (q >= x.min) hit = x; }); return hit; }
    function nextTier(q) { return tiers.filter(function (x) { return q < x.min; })[0] || null; }
    /* Zeilenpreis wie bei Shopify: Der Mengenrabatt wird je Dose abgezogen und dabei
       auf ganze Cent abgerundet (9,98 € − 5 % = 9,49 €), dann mal Menge. */
    function lineTotal(unitPrice, q) { var tr = tierFor(q); return (tr ? unitPrice - Math.floor(unitPrice * tr.pct / 100) : unitPrice) * q; }
    function mode() { var m = root.querySelector('[data-ew-mode]:checked'); return m ? m.value : 'one'; }
    function currentPlan() { var c = root.querySelector('[data-ew-planopt]:checked'); return plans.filter(function (p) { return p.inp === c; })[0] || plans[0]; }

    if (dec) dec.addEventListener('click', function () { setQty(qty() - 1); });
    if (inc) inc.addEventListener('click', function () { setQty(qty() + 1); });
    picks.forEach(function (b) {
      var n = parseInt(b.dataset.ewPick, 10), tr = tierFor(n), f = b.querySelector('[data-ew-pickflag]');
      if (f && tr) { f.textContent = '−' + tr.pct + ' %'; f.hidden = false; }
      b.addEventListener('click', function () { setQty(n); });
    });

    function update() {
      var q = qty(), sub = mode() === 'sub' && plans.length > 0, tr = tierFor(q), nx = nextTier(q);
      var full = unit * q, one = lineTotal(unit, q);
      /* Abo-Karten für die gewählte Dosenzahl */
      var best = 0;
      plans.forEach(function (p) {
        var tot = planPrice(unit, p.type, p.value) * q, save = one - tot, pct = one > 0 ? Math.round(save / one * 100) : 0;
        if (pct > best) best = pct;
        var pr = p.label.querySelector('[data-ew-planprice]'), per = p.label.querySelector('[data-ew-planper]'), sv = p.label.querySelector('[data-ew-plansave]');
        if (pr) pr.textContent = money(tot, cur);
        if (per) per.textContent = 'je Lieferung';
        if (sv) {
          if (save > 0) {
            if (p.yearly) { var yearSave = save * 12, cans = Math.floor(yearSave / (one / q)); sv.textContent = 'Du sparst ' + money(yearSave, cur, 0) + ' im Jahr' + (cans >= 1 ? ' – das sind rund ' + (cans === 1 ? 'eine Dose' : cans + ' Dosen') + ' geschenkt.' : '.'); }
            else sv.textContent = 'Du sparst ' + money(save, cur) + ' je Lieferung (' + pct + ' %).';
            sv.hidden = false;
          } else sv.hidden = true;
        }
      });
      if (modeSave) { modeSave.textContent = best > 0 ? 'bis zu −' + best + ' %' : ''; modeSave.hidden = best <= 0; }
      if (plansBox) plansBox.hidden = !sub;
      /* Preis, Hinweise, Button */
      var p = sub ? currentPlan() : null;
      var total = p ? planPrice(unit, p.type, p.value) * q : one; /* Abo: kein Mengenrabatt */
      if (planIn) { if (p) { planIn.value = p.inp.value; planIn.disabled = false; } else { planIn.value = ''; planIn.disabled = true; } }
      if (dec) dec.disabled = q <= 1;
      if (inc) inc.disabled = q >= maxQ;
      picks.forEach(function (b) { var on = parseInt(b.dataset.ewPick, 10) === q; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      if (cansUnit) { var kg = q * grams / 1000; cansUnit.textContent = (q === 1 ? 'Dose' : 'Dosen') + ' à ' + grams + ' g · ' + (kg >= 1 ? kg.toLocaleString('de-AT', { maximumFractionDigits: 1 }) + ' kg' : (q * grams) + ' g'); }
      if (tierEl) {
        var msg = (tr && !sub) ? '−' + tr.pct + ' % Mengenrabatt ab ' + tr.min + ' Dosen ist abgezogen.' : '';
        if (nx && !sub) msg += (msg ? ' ' : '') + 'Noch ' + cansText(nx.min - q) + ' bis −' + nx.pct + ' %.';
        tierEl.textContent = msg; tierEl.hidden = !msg; tierEl.classList.toggle('is-on', !!tr && !sub);
      }
      if (priceEl) priceEl.textContent = money(total, cur);
      if (wasEl) { if (total < full) { wasEl.textContent = money(full, cur); wasEl.hidden = false; } else wasEl.hidden = true; }
      if (unitLine) unitLine.textContent = cansText(q) + ' à ' + grams + ' g · ' + money(total / q, cur) + ' je Dose · Grundpreis ' + money(total / (q * grams) * 1000, cur) + ' / kg';
      if (yearLine) {
        if (p && p.yearly && one - total > 0) { var ys = (one - total) * 12, yc = Math.floor(ys / (one / q)); yearLine.textContent = 'Jahres-Abo: 12 Lieferungen, monatlich abgebucht – du sparst ' + money(ys, cur, 0) + ' im Jahr' + (yc >= 1 ? ', das sind rund ' + (yc === 1 ? 'eine Dose' : yc + ' Dosen') + ' geschenkt.' : '.'); yearLine.hidden = false; }
        else yearLine.hidden = true;
      }
      if (btnText && root.dataset.cta) btnText.textContent = p ? (root.dataset.subCta || 'Abo starten') + ' – ' + money(total, cur) + ' je Lieferung' : root.dataset.cta;
      document.dispatchEvent(new CustomEvent('ew:variant', { detail: { id: vid ? vid.value : '', price: money(total, cur), plan: p ? p.inp.value : '', qty: q } }));
    }
    root.addEventListener('change', update);
    if (qtyIn) qtyIn.addEventListener('input', function () { if (qtyIn.value !== '') update(); });
    /* Futterrechner: berechnete Dosenzahl übernehmen */
    document.addEventListener('ew:selectvariant', function (e) {
      if (!e.detail || !e.detail.qty) return;
      setQty(e.detail.qty);
      if (qtyBox) { qtyBox.classList.add('is-flash'); setTimeout(function () { qtyBox.classList.remove('is-flash'); }, 1600); }
    });
    var submit = root.querySelector('[data-ew-submit]');
    if (btnText && !(submit && submit.disabled)) root.dataset.cta = btnText.textContent;
    update();
  }
  function run() { Array.prototype.forEach.call(document.querySelectorAll('[data-ew-buy]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();